import { CURRENCIES } from '../constants';

const getCurrencyByCode = (code) => {
  const currency = CURRENCIES.find(({ code: currencyCode }) => currencyCode === code);
  return currency || {};
};

const getCurrencyBySign = (sign) => {
  const currency = CURRENCIES.find(({ sign: currencySign }) => currencySign === sign);
  return currency || {};
};

const getCurrencyByLanguage = (language) => {
  if (language === 'en-GB') return CURRENCIES.find(({ code }) => code === 'GBP');
  if (language === 'en-US') return CURRENCIES.find(({ code }) => code === 'USD');
  return CURRENCIES.find(({ code }) => code === 'EUR');
};

const getCurrencyByCountryCode = (countryCode) => {
  switch (countryCode) {
    case 'gb':
      return getCurrencyByCode('GBP');
    case 'us':
    case 'ca':
      return getCurrencyByCode('USD');
    default:
      return getCurrencyByCode('EUR');
  }
};

export {
  getCurrencyByCode,
  getCurrencyBySign,
  getCurrencyByLanguage,
  getCurrencyByCountryCode,
};
